var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8334 0.333344C16.2141 0.333344 17.3334 1.45263 17.3334 2.83334V11.1667C17.3334 12.5474 16.2141 13.6667 14.8334 13.6667H3.16669C1.78598 13.6667 0.666687 12.5474 0.666687 11.1667V2.83334C0.666687 1.45263 1.78598 0.333344 3.16669 0.333344H14.8334ZM2.33335 7.00001V11.1667C2.33335 11.6269 2.70645 12 3.16669 12H14.8334C15.2936 12 15.6667 11.6269 15.6667 11.1667V7.00001H2.33335ZM2.33335 3.66668H15.6667V2.83334C15.6667 2.37311 15.2936 2.00001 14.8334 2.00001H3.16669C2.70645 2.00001 2.33335 2.37311 2.33335 2.83334V3.66668Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/transactionsIcon.dbdf87ee.svg";
export { ForwardRef as ReactComponent };